export default {"src":"/_next/static/media/carbon_delivery-parcel.d403a0f4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};